import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { LayoutSubHeaderComponent } from '../../layouts/layout-sub-header/layout-sub-header.component';

@Component({
  selector: 'app-sub-header-main',
  imports: [LayoutSubHeaderComponent, NzIconDirective],
  templateUrl: './sub-header-main.component.html',
  styleUrl: './sub-header-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubHeaderMainComponent {
  readonly title = input('');
  readonly showBackButton = input(false);

  readonly back = output<void>();

  handleBack() {
    this.back.emit();
  }
}
